import styled from 'styled-components';

export const CampaignWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
`;

export const CampaignContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 760px;
  padding: 0 20px;
`;

export const WepickBoxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  font-size: 2em;
  font-weight: 600;
`;

export const CampaignBox = styled.div`
  width: 100%;
  margin: 10px 0;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
`;

export const BannerImage = styled.img`
  width: 100%;
  // height: 210px;
  object-fit: contain;
`;

export const CampaignTitle = styled.div`
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 16px;
`;

export const CampaignInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 100%;

  padding: 20px;
  gap: 8px;
  line-height: 17px;

  background-color: #f6f6f6;
`;

export const CampaignInfoText = styled.div`
  font-size: 14px;
`;

export const CampaignInfoBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 3em;
  color: white;
  background-color: #0043CC;
  border-radius: 2em;
  padding: 0 5px;
  font-size: 1em;
  font-size: '14px';

  white-space: nowrap;

  &:hover {
    background-color: #047af2;
  }

  @media (max-width: 300px) {
    font-size: 11px;
  }
`;

export const TotalPointBox = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 760px;
  height: 100%;

  margin: 5px;

  font-size: 25px;
  font-weight: 700;
  line-height: 30px;
`;

export const TotalPointTitle = styled.div`
  font-size: 15px;
  font-weight: 400;
`;

export const Tabs = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: 45px;
  gap: 15px;
  padding: 0 20px;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  max-width: 760px;
  position: relative;
  border-bottom: 2px solid #f1f3f5;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
`;

export const Tab = styled.div<{ isSelected: boolean }>`
  font-weight: ${props => (props.isSelected ? '800' : '400')};
  padding: 10px 5px;
  font-size: 15px;
  cursor: pointer;
  position: relative;
  z-index: ${props => (props.isSelected ? 1 : 0)};
  border-bottom: ${props => (props.isSelected ? '2px solid black' : 'none')};
  scroll-snap-align: start;
  height: 100%;

  cursor: pointer;
`;

export const ListTopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  width: 100%;
  padding: 15px 20px;
  max-width: 760px;
  background-color: white;
  margin-top: 3px;
`;

export const GreenButton = styled.button`
  background-color: #57D958;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  font-size: 15px;
  color: white;
  width: 100%;
  border-radius: 5px;

  &:hover {
    background-color: darkgreen;
  }

  &:focus {
    background-color: darkgreen;
  }
`;

export const IFError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 20px;
  color: #333;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  // make this IFError to be located at the center of the screen
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  
`;